import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { fx } from '../../fx.js';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Label + control + hint or error. Children is the control (style it with inputS). An error
 * recolours the child's border coral.
 *
 * @param {object} p
 * @param {boolean} [p.optional]
 * @param {React.ReactNode} [p.warning]
 * @param {React.ReactNode} p.label
 * @param {React.ReactNode} [p.hint]
 * @param {React.ReactNode} [p.error]
 * @param {React.ReactElement} p.children
 */
export function Field({ label, hint, error, warning, optional, children }) {
  const box = React.useRef(null);
  React.useEffect(() => { if (error && fx.shake) fx.shake(box.current); }, [error]);
  return h('label', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
    h('span', { style: { fontFamily: BODY, fontSize: 11, fontWeight: 800, letterSpacing: 'var(--track-field)', textTransform: 'uppercase', color: 'var(--tx2)' } }, label, optional ? h('span', { style: { textTransform: 'none', letterSpacing: 0, fontWeight: 600, color: 'var(--mut2)', marginLeft: 6 } }, '(optional)') : null),
    h('span', { ref: box, style: { display: 'block' } }, React.isValidElement(children) && error ? React.cloneElement(children, { style: { ...(children.props.style || {}), borderColor: 'var(--coral)' }, 'aria-invalid': true }) : children),
    error ? h('span', { role: 'alert', style: { display: 'flex', gap: 5, alignItems: 'flex-start', fontSize: 12, color: 'var(--coral-tx)', fontWeight: 600 } }, Icon ? h(Icon, { name: 'circle-alert', size: 14, style: { marginTop: 1 } }) : null, error) : warning ? h('span', { role: 'status', style: { display: 'flex', gap: 5, alignItems: 'flex-start', fontSize: 12, color: 'var(--gold-tx)', fontWeight: 600 } }, Icon ? h(Icon, { name: 'triangle-alert', size: 14, style: { marginTop: 1 } }) : null, warning) : hint ? h('span', { style: { fontSize: 12, color: 'var(--mut2)' } }, hint) : null
  );
}
